module.exports = __webpack_public_path__ + "static/img/no-permission.c936359.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/no-permission.png
// module id = VwZg
// module chunks = 1